import { NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom';

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (to: To, options?: NavigateOptions) => {
    if (Number(to)) {
        navigate(to, options);
        return;
    }
    navigate(`${to}${location.search}`, options);
  };
};
